import { render, staticRenderFns } from "./FlagChart.vue?vue&type=template&id=531f560a&scoped=true&"
import script from "./FlagChart.vue?vue&type=script&lang=js&"
export * from "./FlagChart.vue?vue&type=script&lang=js&"
import style0 from "./FlagChart.vue?vue&type=style&index=0&id=531f560a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f560a",
  null
  
)

export default component.exports